import {RawMaterialDto} from '@sharedrest/data.restservice';
import {MatrixDto} from '@sharedrest/equation.restservice';
import { SampleDto } from '@sharedcommon/model/sample/sample.model';

export class UserResultPref {
  id: number;
  rawMaterialOrSample: RawMaterialDto|SampleDto;
  matrix: MatrixDto;
  valueType: UserResultPrefValueType;
}

export enum UserResultPrefValueType {
  CALCULATED = 'label.user.rawmaterials.result.calculated',
  SAVED = 'label.user.rawmaterials.result.saved',
  STANDARD = 'label.user.rawmaterials.result.standard'
}


